import type { FaireAdCampaignEntity } from "../../entity_types/adCampaign";

export const campP4UnderUtilizedReorder: FaireAdCampaignEntity = {
  token: "camp_p4_under_utilized_reorder",
  type: "adCampaign",
  advertiserProfileToken: "adv_p4_under_utilized",
  segment: "REORDER_MARKETPLACE",
  status: "RUNNING",
  monthlyBudgetDollars: 500,
  startedRunningAt: "2025-03-15",
  segmentMetrics: {
    numReorderConversions: 74,
    salesDollars: 36720,
    totalAdsSpendDollars: 2786,
    returnOnAdSpend: 13.18,
  },
  performancePeriodTokens: [
    "perf_p4_under_utilized_reorder_202510",
    "perf_p4_under_utilized_reorder_202511",
    "perf_p4_under_utilized_reorder_202512",
    "perf_p4_under_utilized_reorder_202601",
    "perf_p4_under_utilized_reorder_202602",
    "perf_p4_under_utilized_reorder_202603",
    "perf_p4_under_utilized_reorder_202604",
    "perf_p4_under_utilized_reorder_202605",
    "perf_p4_under_utilized_reorder_202606",
  ],
  meta: {
    source: "mock",
    importedAt: "2026-07-06T00:00:00.000Z",
    importedBy: "advertiser-profiles",
  },
};
